/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosPromise } from 'axios';
import { call, put, take, takeEvery } from 'redux-saga/effects';
import { api } from 'services/api';
import { PayloadAction } from '@reduxjs/toolkit';
import { notificationContainer } from 'utils/notificationContainer';
import { DateTime } from 'luxon';
import {
	TGetNewMessageCountResponsePayload,
	TMarkAsReadMessageRequest,
	TDeleteMessageRequest,
	TMessagesResponsePayload,
	TOrganizationsResponsePayload,
	TUserInfoResponsePayload,
	THubspotVisitorTokenResponsePayload,
} from './types';

import {
	getMessagesRequest,
	getMessagesSuccess,
	getNewMessageCountRequest,
	getNewMessageCountSuccess,
	markAsReadMessageRequest,
	markAsReadMessageSuccess,
	deleteMessageRequest,
	deleteMessageSuccess,
	getOrganizationsRequest,
	getOrganizationsSuccess,
	getUserInfoRequest,
	getUserInfoSuccess,
	getHubspotVisitorTokenRequest,
	getHubspotVisitorTokenSuccess,
} from './reducer';
import { refreshTokenByTimeOutRequest, refreshTokenByTimeOutSuccess } from '../auth/reducer';
import { getAuth, getAuthRefreshToken, getRefreshTokenLoader } from '../auth/selectors';
import { refreshTokenByTimeOutWorker } from '../auth/saga';

function* getOrganizationsWorker() {
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TOrganizationsResponsePayload = yield call(api.user.getOrganizations);
		yield put(getOrganizationsSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
		// yield put(userInitState());
	}
}

function* getUserInfoRequestWorker() {
	try {
		yield put(refreshTokenByTimeOutRequest());
		console.log('getUserInfoRequestWorker refreshTokenByTimeOutRequest');
		yield take(refreshTokenByTimeOutSuccess.type);
		console.log('getUserInfoRequestWorker refreshTokenByTimeOutSuccess');
		console.log('getUserInfoRequestWorker try');
		const response: TUserInfoResponsePayload = yield call(api.user.getUserInfo);
		console.log('getUserInfoRequestWorker response', response);
		yield put(getUserInfoSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error), 'error');
		}
		// yield put(userInitState());
	} finally {
		// yield put(hideLoading());
	}
}

export function* userSaga() {
	yield takeEvery(getOrganizationsRequest.type, getOrganizationsWorker);
	yield takeEvery(getUserInfoRequest.type, getUserInfoRequestWorker);
}
